<template>
<div style="background-color: white;">
 <el-col  class="content">
   <div style="
   padding-bottom: 200px;
                margin-top: 2.9vh;
                letter-spacing: 0;">
     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;The global daily maximum and minimum temperature for the period from 1950 through 2100 were retrieved from NEX-GDDP dataset, including downscaled projections from the 21 models under RCP4.5 and RCP8.5 greenhouse gas emissions scenarios for which daily datasets were produced and distributed under CMIP5. The spatial resolution of the dataset is 0.25 degrees (~25 km × 25 km). In addition, the projection with the same resolution for RCP 2.6 from the 13 models were assimilated by the Institute of Atmospheric Physics (IAP), Chinese Academy of Sciences (CAS), which covers the region between 60˚S and 90˚N (Xu and Wang, 2019). The NEX-GDDP dataset can be freely accessed on this website: https://www.nccs.nasa.gov/services/data-collections/land-based-products/nex-gddp.
     <br/><br/>
     &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Here the temporal range was divided into three periods: the historical period (2000s) defined as 1986—2005, the future period 2030s (2016—2035), and the future period 2050s (2046—2065). Note that summer and winter refer to June-July-August (JJA) and December-January-February (DJF), respectively. Furthermore, the extreme temperature was measured by both of an absolute index (TXx) and two percentile indices (TX90p and TN10p) according to the definitions of extremes indices recommended by the Expert Team on Climate Change Detection and Indices (ETCCDI) (Karl & Easterling, 1999; Zhang et al., 2011; Fan et al., 2020).Tmean is defined as the average of daily minimum and maximum temperature. Tstd is defined as the standard deviation of the daily mean temperature. TXx refers to the multi-model ensemble of annual maximum near-surface air temperature during the historical period or future temporal periods based on NEX-GDDP models. TX90p (TN10p) refers to as the percentage of days with the daily maximum (minimum) temperature exceeding (below) the local calendar day 90th (10th) percentile centered on a 5-day window for the base period 1961–90. In addition, The Tmean change was calculated by subtracted the Tmean during the historical period (2000s) from the Tmean under the RCP scenarios in the future. The model uncertainty of the Tmean was represented by the standard deviation of the Tmean under the RCP scenarios during the different periods based on all selected models. Changes and model uncertainties of Tstd, TXx, TX90p, and TN10p are same as Tmean.

   </div>
 </el-col>
</div>
</template>

<script>
export default {
  name: "TemperatureChanges"
}
</script>

<style scoped>
.content{
  text-align: left;
  padding: 2vw 2vw;
  height: 100vh;
  overflow-y: scroll;
  color: black;
  padding-bottom: 5vh;

  font-family: Calibri;
  line-height: 40px;
  font-size: 2.2rem;
  font-weight: normal;
}

.content::-webkit-scrollbar {
  display: none;/*隐藏滚动条*/
}
</style>



// WEBPACK FOOTER //
// src/view/BSD/About/TemperatureChanges.vue